import React from 'react'

import { faEye, faEyeSlash, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ConfirmationDialog } from '@scoir/modals'

const useStyles = makeStyles((theme) => ({
  icon: {
    width: theme.spacing(2.25),
    height: theme.spacing(2.25),
  },
}))

type BulkEditProps = {
  onBulkUpdateContentVisibility: (visibility: boolean) => void
  onBulkDeleteContent: () => void
}

const BulkEdit = ({ onBulkUpdateContentVisibility, onBulkDeleteContent }: BulkEditProps) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)

  const handleDeleteContent = () => {
    onBulkDeleteContent()
    setOpen(false)
  }
  return (
    <Box
      display="flex"
      gridGap={16}
    >
      <Button
        color="primary"
        variant="outlined"
        onClick={() => onBulkUpdateContentVisibility(false)}
        startIcon={
          <FontAwesomeIcon
            icon={faEye}
            className={classes.icon}
          />
        }
      >
        Set as Live
      </Button>
      <Button
        color="primary"
        variant="outlined"
        onClick={() => onBulkUpdateContentVisibility(true)}
        startIcon={
          <FontAwesomeIcon
            icon={faEyeSlash}
            className={classes.icon}
          />
        }
      >
        Set as Hidden
      </Button>
      <Button
        color="primary"
        variant="outlined"
        onClick={() => setOpen(true)}
        startIcon={
          <FontAwesomeIcon
            icon={faTrashAlt}
            className={classes.icon}
          />
        }
      >
        Delete
      </Button>
      <ConfirmationDialog
        open={open}
        headerText="Delete selected content?"
        confirmationText="Confirm Delete"
        onConfirm={handleDeleteContent}
        onClose={() => setOpen(false)}
      >
        <Typography>
          This content will be removed from your profile and search. This action cannot be undone.
        </Typography>
      </ConfirmationDialog>
    </Box>
  )
}
export default BulkEdit
